import React from 'react';

const AddDoctor = () => {

    return (
        <div>
            <h1>AddDoctor</h1>
        </div>
    );
};

export default AddDoctor;